// @flow

import * as React from 'react';

import { useField } from 'react-final-form';

import type { ProductData } from '@gandi/cart';
import { Base } from '@gandi/ui';

import { CERT_TYPE_PROTECT_INPUT_NAME } from '../../consts';
import type { CertificateApiResponse, FormValues } from '../../types';

import { CSROption } from './CSROption';
import { SANOption } from './SANOption';
import { StoredCertCNOption } from './StoredCertCNOption';

export type StepCSRProps = {
  certToRenew?: CertificateApiResponse,
  isStored?: boolean,
  // required for not full auto cert
  formDataMapper: (formValues: FormValues) => void | ProductData,
};

export function StepCSR({
  certToRenew,
  isStored,
  formDataMapper,
}: StepCSRProps): React.MixedElement {
  const {
    input: { value: protect },
  } = useField(CERT_TYPE_PROTECT_INPUT_NAME);

  const isMulti = protect === 'multi';

  return (
    <>
      {isStored ? (
        <StoredCertCNOption />
      ) : (
        <CSROption certToRenew={certToRenew} formDataMapper={formDataMapper} />
      )}

      {isMulti && (
        <Base marginTop="base">
          <SANOption isRenew={!!certToRenew} isStored={isStored} />
        </Base>
      )}
    </>
  );
}
